import { Button } from '@chakra-ui/react';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

type Props = {
  isExpanded: boolean;
  onToggle: () => void;
};

export function ExpandTableToggle({ isExpanded, onToggle }: Props) {
  return (
    <Button
      variant="link"
      color="#0941A8"
      fontSize="sm"
      fontWeight="500"
      alignSelf="flex-end"
      onClick={onToggle}
      leftIcon={<OpenInFullIcon sx={{ fontSize: 16 }} />}
      _hover={{ textDecoration: 'underline' }}
    >
      {isExpanded ? 'Collapse Table' : 'Expand Table'}
    </Button>
  );
}
